import uuidv4 from 'uuid/v4';
import {
  ArticleFormat,
  ArticleStatus,
  BrandKey,
  GetArticleQuery_query_article_Article,
} from '../../../__generated__/queries-web';
import { getArticleMachineTag } from './TypeFactory';

const emptyConfig: any = {
  __typename: 'Article',
  id: '',
  title: '',
  secondaryTitle: '',
  partnerTitle: '',
  medias: '',
  lead: null,
  body: null,
  publishedAt: '',
  editedAt: '',
  slug: '',
  status: ArticleStatus.Draft,
  categories: [],
  tags: [],
  authors: [],
  source: null,
  events: [],
  urls: [],
  qualifiers: [],
  guides: [],
  channels: [],
  live: null,
  url: null,
};

export const emptyArticle = (brandKey: BrandKey, format: string) => ({
  ...emptyConfig,
  id: uuidv4(),
  brandKey,
  format: format === 'article' ? ArticleFormat.Rich : ArticleFormat.Video,
});

export const createArticleData = (
  assignmentId: string,
  format: string,
  data: Partial<GetArticleQuery_query_article_Article>,
): GetArticleQuery_query_article_Article => ({
  ...emptyConfig,
  id: uuidv4(),
  ...data,
  format: format === 'article' ? ArticleFormat.Rich : ArticleFormat.Video,
  machineTags: [getArticleMachineTag({ assignmentId })],
});
